import React from "react";
import "./Warehousing.css";
import { FaWarehouse, FaShieldAlt, FaSyncAlt, FaBoxes } from "react-icons/fa";
import { Link } from "react-router-dom";

function Warehousing() {
  return (
    <div className="warehouse-wrapper">

      {/* HERO SECTION */}
      <section className="warehouse-hero">
        <div className="warehouse-hero-container">

          <div className="warehouse-hero-icon-title">
            <FaWarehouse size={48} className="warehouse-icon-green" />
            <h1 className="warehouse-hero-title">
              Secure and Strategic Warehousing Solutions
            </h1>
          </div>

          <p className="warehouse-hero-subtext">
            Our warehousing services offer secure, efficient, and flexible storage
            solutions with world-class facilities and robust security.
          </p>

          <ul className="warehouse-hero-points">
            <li><FaShieldAlt className="me-2" /> <strong>Security:</strong> Advanced surveillance & access control.</li>
            <li><FaSyncAlt className="me-2" /> <strong>Flexibility:</strong> Short-term or long-term storage options.</li>
            <li><FaBoxes className="me-2" /> <strong>Efficiency:</strong> Fast order processing & distribution.</li>
          </ul>

          <Link to="/" className="warehouse-back-btn">Back to Home</Link>
        </div>
      </section>

      {/* FEATURES GRID */}
      <section className="warehouse-features-section">
        <div className="warehouse-features-grid">

          <div className="warehouse-feature-card">
            <h3>Real-Time Inventory Accuracy</h3>
            <p>
              Automated tracking gives you complete visibility on your stock.
            </p>
          </div>

          <div className="warehouse-feature-card">
            <h3>Secure Storage Facilities</h3>
            <p>
              24/7 surveillance, restricted access, and protected storage zones.
            </p>
          </div>

          <div className="warehouse-feature-card">
            <h3>Kitting & Value-Added Services</h3>
            <p>
              Pick, pack, labeling, and custom packaging to streamline shipping.
            </p>
          </div>

          <div className="warehouse-feature-card">
            <h3>Distribution & Fulfillment</h3>
            <p>
              Fast and efficient dispatch to wholesalers or customers.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
}

export default Warehousing;
